
<v-chip
  :small="small"
  class="status-badge"
  :class="`status-badge--${type}`"
  :aria-label="ariaLabel || `Status: ${status}`"
  :data-testid="`status-badge-${type}`"
>
  <v-icon
    v-if="showIcon"
    left
    :x-small="small"
    :small="!small"
    :aria-hidden="true"
  >
    {{ computedIcon }}
  </v-icon>
  {{ status }}
</v-chip>
